(function () {
  'use strict';

  function init(root) {
    if (root.dataset.collistInit === '1') return;
    root.dataset.collistInit = '1';

    var track = root.querySelector('[data-collist-track]');
    var prev = root.querySelector('[data-collist-prev]');
    var next = root.querySelector('[data-collist-next]');
    if (!track) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      var hasOverflow = max > 2;
      if (prev) prev.hidden = !hasOverflow || track.scrollLeft <= 2;
      if (next) next.hidden = !hasOverflow || track.scrollLeft >= max;
    }

    function step(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
    }

    if (next) next.addEventListener('click', function () { step(1); });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // Görseller yüklendikçe scrollWidth değişir; birkaç kez güncelle
    update();
    window.addEventListener('load', update);
    setTimeout(update, 400);
  }

  function initAll() {
    document.querySelectorAll('[data-collist]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-collist]');
    if (el) init(el);
  });
})();
